import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const ProceduresView = ({ procedures, isAdminister = false }) => {
  const { clinicStocks } = useSelector((state) => state?.clinic);

  const reqAdminList = () => {
    return procedures
      ?.flatMap((proc) => proc?.procedureDetails || [])
      ?.filter((det) => det?.type === "Administered" && det?.status === "true");
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId
    );
    return reqStock?.stockBatch ?? [];
  };

  const renderAdministerRecord = () => {
    return reqAdminList()?.map((li, i) => {
      return (
        <div className="gray-back-con1 mv5" key={`${li?.detailId}-${i}`}>
          <div className="flex-row-ali-cen flex-row-wrap">
            <Typography className="txt-semi-bold black fs12">
              Name: {li?.procedureName}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Quantity:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {li?.quantity ?? "1"}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Batch Number:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {getBatchList(li?.stockId)?.find(
                (bat) => bat?.batchId === li?.batchId
              )?.batchNo ?? ""}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">Dosage:</Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {li?.dosage ?? ""}{" "}
              {`/${
                li?.batchId
                  ? getBatchList(li?.stockId)?.find(
                      (bat) => bat?.batchId === li?.batchId
                    )?.packageUom ?? ""
                  : getBatchList(li?.stockId)?.[0]?.packageUom ?? ""
              }`}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">Route:</Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {li?.route ?? ""}
            </Typography>
          </div>
        </div>
      );
    });
  };

  const renderRecord = () => {
    return procedures?.map((li, i) => {
      return (
        <div className="gray-back-con1 mv5" key={`${li?.procedureId}-${i}`}>
          <div className="flex-row-ali-cen flex-row-wrap">
            <Typography className="txt-semi-bold black fs12">
              Name: {li?.procedureName}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Service Type:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {li?.serviceType ?? ""}
            </Typography>
          </div>
        </div>
      );
    });
  };

  return <div>{isAdminister ? renderAdministerRecord() : renderRecord()}</div>;
};

export default ProceduresView;
